<template>
  <div>
    <v-file-input
      style="direction: ltr"
      :label="title"
      :required="required"
      :rules="required ? [(v) => !!v || requiredText] : []"
      outlined
      show-size
      ref="file"
      :clearable="false"
      dense
      v-model="uploadedFilesModel"
      :disabled="
        (singleFile && uploadedFiles.length > 0) || imageLoader ? true : false
      "
      @change="uploadFile($event)"
    ></v-file-input>
    <div class="d-flex flex-row flex-warp">
      <div
        v-for="(uploadedFile, index) in uploadedFiles"
        :key="index"
        class="m-2"
      >
        <v-img
          contain
          class="rounded lighten-2"
          :src="uploadedFile.thumbnailFileUrl"
          @click="openImage(uploadedFile.fileUrl)"
          max-height="50"
          max-width="50"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="primary lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <label
          @click="removeImg(uploadedFile)"
          target="_blank"
          class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
          data-action="change"
          data-toggle="tooltip"
          title="حذف فایل "
          data-original-title="Change avatar"
          style="z-index: 1"
        >
          <i class="ki ki-bold-close icon-xs text-danger"></i>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Helper from '@/core/helpers';
import { RepoFactory } from '@/baseRepository/Factory';
const filesRepository = () => RepoFactory.get('files');
export default {
  props: {
    files: {
      type: Array,
      default: undefined,
    },
    singleFile: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'انتخاب فایل',
    },
    required: {
      type: Boolean,
      default: false,
    },
    requiredText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      file: null,
      uploadedFiles: [],
      uploadedFilesId: [],
      uploadedFilesModel: [],
      imageLoader: false,
    };
  },
  created() {
    this.uploadedFiles = this.files;
    this.uploadedFiles.forEach((element) => {
      this.uploadedFilesId.push(element.fileId);
    });
  },
  computed: {
    fileBaseUrl() {
      return this.$store.getters.fileBaseUrl;
    },
  },
  methods: {
    removeImg(item) {
      this.uploadedFilesModel = [];
      const indx = this.uploadedFiles.findIndex(
        (v) => v.thumbnailFileUrl === item.thumbnailFileUrl
      );
      this.uploadedFiles.splice(indx, indx >= 0 ? 1 : 0);
      const indx2 = this.uploadedFilesId.findIndex((v) => v == item.fileId);
      this.uploadedFilesId.splice(indx2, indx2 >= 0 ? 1 : 0);
    },
    openImage(url) {
      window.open(url, '_blank');
    },
    uploadFile(file) {
      this.imageLoader = true;
      this.file = null;
      const check = this.$refs.file.validate();
      if (!check) {
        return false;
      }
      this.file = file;
      this.loader = this.$loading.show();
      let fil = new FormData();
      fil.append('file', file);
      filesRepository()
        .sendFileWithoutFolderType(fil, this.fileBaseUrl)
        .then(({ data }) => {
          this.uploadedFiles.push({
            fileId: data.fileId.replaceAll('-', ''),
            thumbnailFileUrl: data.links[0].href + '/thumbnail',
            fileUrl: data.links[0].href,
          });
          this.uploadedFilesId.push(data.fileId);
          this.$emit('fileChanged', this.uploadedFiles);
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        })
        .finally(() => {
          this.loader.hide();
          this.imageLoader = false;
        });
    },
  },
};
</script>

<style></style>
